import {
  isWidget,
  isRetailerSubUser,
} from "@faire/deprecated-retailer-visitor-shared/lib/signUpRevampUtils";
import {
  ENDING_STEP_PERCENTAGE,
  signUpStepProgressionPercentage,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/signUpStepsProgression";
import {
  Step,
  stepKeyToPathMap,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { removeLocaleFromUrl } from "@faire/web/ui/routing/util";
import { useLocation } from "react-router-dom";

export const useSignupProgression = () => {
  const location = useLocation();

  const currentPath = removeLocaleFromUrl(location.pathname);
  const currentStep = Object.entries(stepKeyToPathMap).find(
    ([_, path]) => path() === currentPath
  )?.[0] as Step;

  // Fallback for ending steps, but we should have mapped all steps
  const signUpPercent =
    signUpStepProgressionPercentage[currentStep] ?? ENDING_STEP_PERCENTAGE;

  const hideProgressBar =
    (currentStep === Step.PERSONAL_INFO && isWidget(location)) ||
    isRetailerSubUser(location);

  return {
    signUpPercent,
    hideProgressBar,
  };
};
